// extracted by mini-css-extract-plugin
export default {"TitledBlock":"TitledBlock_TitledBlock__ey413","Body":"TitledBlock_Body__acoxv","TxtTitle":"TitledBlock_TxtTitle__F2bCg"};